import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ElementRef, Inject, Injectable, PLATFORM_ID, Renderer2, ViewChild, inject } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AlertMsgModel, destinationCard } from '../interfaces';
import { EnvironmentService } from './environment.service';
import { IAirPortTranslated } from '../../components/popular-airlines/models/airlineInfo.models';
import { TranslateService } from '@ngx-translate/core';
import { NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, switchMap, retry, finalize } from 'rxjs';
import { StorageService } from './storage-services.service';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  public http = inject(HttpClient);
  public environment = inject(EnvironmentService);
  translate = inject(TranslateService);
  router = inject(Router);
  cities: IAirPortTranslated[] = []; // Access the `default` property
  // egyCities: airPorts[] = []; // Access the `default` property

  landCity = '';
  phonenumber = '';
  headerView: boolean = true;
  checkoutPOS = 'EG';

  yesOrNoVaild?: boolean;
  packageVaild?: boolean;
  addbuttonVaild?: boolean;
  hotelTab = false;
  roundTripDatepickerMobileView = false;
  mySafeUrl: null | SafeResourceUrl = null;

  landingAirports: IAirPortTranslated[] = [];
  departingAirports: IAirPortTranslated[] = [];
  private platformId = inject(PLATFORM_ID);
  isBrowser = false;
  screenWidth = 0;

  constructor() {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      const landingAirports = localStorage.getItem('landingAirports');
      const departingAirports = localStorage.getItem('departingAirports');

      if (landingAirports) {
        this.landingAirports = JSON.parse(landingAirports);
      }

      if (departingAirports) {
        this.departingAirports = JSON.parse(departingAirports);
      }
    }
  }

  initialRecommendedAirports: IAirPortTranslated[] = [
    {
      en: {
        airportCode: 'CAI',
        airportName: 'Cairo International Airport',
        cityName: 'Cairo',
        cityCode: 'CAI',
        countryCode: 'EG',
        countryName: 'Egypt',
        regionName: 'Africa',
      },
      ar: {
        airportCode: 'CAI',
        airportName: 'مطار القاهرة الدولي',
        cityName: 'القاهرة',
        cityCode: 'CAI',
        countryCode: 'EG',
        countryName: 'مصر',
        regionName: 'Africa',
      },
    },
    {
      en: {
        airportCode: 'KWI',
        airportName: 'Kuwait International Airport',
        cityName: 'Kuwait',
        cityCode: 'KWI',
        countryCode: 'KW',
        countryName: 'Kuwait',
        regionName: 'Asia',
      },
      ar: {
        airportCode: 'KWI',
        airportName: 'مطار الكويت الدولى ',
        cityName: 'مدينة الكويت',
        cityCode: 'KWI',
        countryCode: 'KW',
        countryName: 'الكويت',
        regionName: 'Asia',
      },
    },
    {
      en: {
        airportCode: 'DXB',
        airportName: 'Dubai International Airport',
        cityName: 'Dubai',
        cityCode: 'DXB',
        countryCode: 'AE',
        countryName: 'United Arab Emirates',
        regionName: 'Asia',
      },
      ar: {
        airportCode: 'DXB',
        airportName: 'دبي',
        cityName: 'دبي',
        cityCode: 'DXB',
        countryCode: 'AE',
        countryName: 'الإمارات العربية المتحدة',
        regionName: 'Asia',
      },
    },
    {
      en: {
        airportCode: 'IST',
        airportName: 'Istanbul',
        cityName: 'Istanbul Ataturk',
        cityCode: 'IST',
        countryCode: 'TR',
        countryName: 'Turkey',
        regionName: 'Asia',
      },
      ar: {
        airportCode: 'IST',
        airportName: 'Istanbul Ataturk',
        cityName: 'اسطنبول',
        cityCode: 'IST',
        countryCode: 'TR',
        countryName: 'تركيا',
        regionName: 'Asia',
      },
    },
    {
      en: {
        airportCode: 'LHR',
        airportName: 'London Heathrow Airport',
        cityName: 'London',
        cityCode: 'LHR',
        countryCode: 'GB',
        countryName: 'United Kingdom of Great Britain and Northern Ireland',
        regionName: 'Europe',
      },
      ar: {
        airportCode: 'LHR',
        airportName: 'مطار لندن هيثرو',
        cityName: 'لندن',
        cityCode: 'LHR',
        countryCode: 'GB',
        countryName: 'المملكة المتحدة لبريطانيا العظمى وأيرلندا الشمالية',
        regionName: 'Europe',
      },
    },
  ];

  clearCities() {
    this.cities = [];
  }

  onSelectLandingAirports(airport: IAirPortTranslated, index: number) {
    this.landingAirports[index] = airport;
  }

  onSelectDepartingAirports(airport: IAirPortTranslated, index: number) {
    this.departingAirports[index] = airport;
  }

  saveSelectedAirportsInStorage() {
    const landingAirports = JSON.stringify(this.landingAirports);
    const departingAirports = JSON.stringify(this.departingAirports);

    localStorage.setItem('landingAirports', landingAirports);
    localStorage.setItem('departingAirports', departingAirports);
  }

  getTopDestination() {
    const Api = `${this.environment.searchflow}/api/FlightsTopDistinations/GetAll`;
    return this.http.get<destinationCard>(Api);
  }

  isSegmentPresent(segment: string): boolean {
    return this.router.url.includes(segment);
  }

  get lang(): 'ar' | 'en' {
    return this.translate.currentLang as ('ar' | 'en')
  }
}
